import '../../styles.scss'

import { useTranslation } from 'react-i18next'
import { Checkbox, Form, Input, Modal } from 'antd'

import B2becAddressForm from '@/components/B2becAddressForm'
import CustomButton from '@/components/CustomButton'
import PermissionWrapper from '@/HOCs/permissionWrapper'
import { ADDRESS_ACTION_TYPES } from '@/libs/constants/actionTypes'
import { MODULE_PROFILE_RIGHTS } from '@/libs/constants/modulerights'

const { confirm } = Modal

const AddressDetailBlock = (props) => {
  const { t } = useTranslation()
  const {
    actionType,
    cancelRequest,
    handleDeleteAddress,
    handleAddAddress,
    handleChangeAddress,
    loading = false,
  } = props

  const renderActionButton = () =>
    actionType === ADDRESS_ACTION_TYPES.CHANGE_ADDRESS
      ? (
        <PermissionWrapper
          permission={MODULE_PROFILE_RIGHTS.REQUEST_DELIVERY_ADDRESS_CHANGE}
        >
          <CustomButton
            className="btn btn--submit mt-6"
            disabled={loading}
            loading={loading}
            type="primary"
            onClick={handleChangeAddress}
          >
            {t('myProfile.button.requestChanges')}
          </CustomButton>
        </PermissionWrapper>
      )
      : (
        <CustomButton
          className="btn btn--submit mt-6"
          disabled={loading}
          loading={loading}
          type="primary"
          onClick={handleAddAddress}
        >
          {t('myProfile.button.addAddress')}
        </CustomButton>
      )

  const showDeleteConfirm = () => {
    confirm({
      title: t('myProfile.deleteAddressModal.title'),
      content: t('myProfile.deleteAddressModal.content'),
      okText: t('myProfile.deleteAddressModal.confirmBtn'),
      okType: 'danger',
      cancelText: t('myProfile.deleteAddressModal.cancelBtn'),
      onOk() {
        handleDeleteAddress()
      },
      onCancel() {},
    })
  }

  const renderDeleteButton = () =>
    actionType === ADDRESS_ACTION_TYPES.CHANGE_ADDRESS
      ? (
        <PermissionWrapper
          permission={MODULE_PROFILE_RIGHTS.REQUEST_DELIVERY_ADDRESS_CHANGE}
        >
          <CustomButton
            buttonSize="small"
            className="btn btn--submit mt-6"
            type="ghost"
            onClick={showDeleteConfirm}
          >
            {t('myProfile.button.deleteThisAddress')}
          </CustomButton>
        </PermissionWrapper>
      )
      : null

  return (
    <div className="mt-6">
      <Form.Item hidden name="partnerNumber">
        <Input disabled />
      </Form.Item>

      <Form.Item hidden name="taxNumber">
        <Input disabled />
      </Form.Item>

      <Form.Item hidden name="phoneNumber">
        <Input disabled />
      </Form.Item>

      <B2becAddressForm />

      <Form.Item
        name="defaultAddress"
        label={t('myProfile.form.deliveryAddress.label')}
        style={{ width: 320 }}
        className="custom-form-item"
        valuePropName="checked"
      >
        <Checkbox>{t('myProfile.form.setAsDefaultAddress')}</Checkbox>
      </Form.Item>
      {renderDeleteButton()}
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <CustomButton
          className="btn btn--submit mt-6"
          disabled={loading}
          type="ghost"
          onClick={cancelRequest}
        >
          {t('myProfile.button.cancel')}
        </CustomButton>
        {renderActionButton()}
      </div>
    </div>
  )
}

export default AddressDetailBlock
